<template>
  <div class="box">
    <swiper :options="swiperOptions" v-if="clientWidth > 768" ref="mySwiper" :auto-play="true"
      class="modulelist6_box swiper-no-swiping exhibition_box">
      <div v-if="clientWidth > 768" class="swiper-button-prev swiper-button-prev-ex-pc swiper-button1"
        slot="button-prev"></div>
      <div v-if="clientWidth > 768" class="swiper-button-next swiper-button-next-ex-pc swiper-button1"
        slot="button-next"></div>
      <swiper-slide v-for="(item, index) in list" :key="index" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index" 
          :data-item="JSON.stringify(val)" style="cursor: pointer;">
          <div class="modulelist6_children_box">
            <div class="modulelist6_img">
              <img v-if="val.img" :src="Res_Url + '/exhibition/' + val.img" alt="" />
              <img v-else :src="Res_Url + '/exhibition/新品展示所有视频的封面.png'" alt="" />
            </div>
            <div class="line6"></div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span v-html="val.title"></span>
                <span v-html="val.introduction.split('/n').join('<br />')"></span>
              </div>

              <div class="modulelist6_right" v-if="tab">
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
              <div class="modulelist6_right" v-else>
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <swiper :options="swiperOption_m" v-else ref="mySwiper" :auto-play="true" class="modulelist6_box exhibition_box">
      <div v-if="clientWidth < 768" class="swiper-button-prev swiper-button-prev-ex-m swiper-button1"
        slot="button-prev"></div>
      <div v-if="clientWidth < 768" class="swiper-button-next swiper-button-next-ex-m swiper-button1"
        slot="button-next"></div>
      <swiper-slide v-for="item in listm" :key="item.title" class="modulelist6">
        <div class="modulelist6_children" v-for="(val, index) in item.children" :key="index"
          :data-item="JSON.stringify(val)" style="cursor: pointer;">
          <div class="modulelist6_children_box">
            <div class="modulelist6_img">
              <img v-if="val.img" :src="Res_Url + '/exhibition/' + val.img" alt="" />
              <img v-else :src="Res_Url + '/exhibition/新品展示所有视频的封面.png'" alt="" />
            </div>
            <div class="line6"></div>
            <div class="modulelist6_content">
              <div class="modulelist6_left">
                <span v-html="val.title"></span>
                <span v-html="val.introduction.split('/n').join('<br />')"></span>
              </div>
              <div class="modulelist6_right" v-if="tab">
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
              <div class="modulelist6_right" v-else>
                <span>查看详情</span>
                <img :src="Res_Url + '/index/icon_next2.png'" alt="" />
              </div>
            </div>
          </div>
        </div>
      </swiper-slide>
    </swiper>
    <div class="intronumber">
      <div class="left"></div>
      <span v-if="clientWidth > 768">{{ currentIndex }}/{{ list.length }}</span>
      <span v-if="clientWidth <= 768">{{ currentIndex_m }}/{{ listm.length }}</span>
      <div class="right"></div>
    </div>
  </div>
</template>

<script>
import {
  Swiper as SwiperClass,
  Pagination,
  Mousewheel,
  Autoplay,
  Navigation,
  EffectFade,
} from "swiper/core";
import getAwesomeSwiper from "vue-awesome-swiper/dist/exporter";
import "swiper/swiper-bundle.min.css";
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass);
SwiperClass.use([Pagination, Mousewheel, Autoplay, Navigation, EffectFade]);
import { Res_Url } from "@/utils/ApiToken.js";
export default {
  props: {
    data: {
      type: Object,
      value: {},
    },
    tab: {
      type: Boolean,
      value: false,
    },
  },
  components: {
    Swiper,
    SwiperSlide,
  },
  mounted() {
    this.currentData = this.data.industrial;
    // 在mounted后绑定全局点击事件
    this.$nextTick(() => {
      this.bindGlobalClickEvents();
      // 确保显示第一张幻灯片
      this.$nextTick(() => {
        this.ensureFirstSlide();
      });
    });
  },
  beforeDestroy() {
    // 清理事件监听器
    document.removeEventListener('click', this.handleGlobalClick);
  },
  data() {
    const that = this;
    return {
      Res_Url: Res_Url,
      currentData: [],
      currentIndex: 1,
      currentIndex_m: 1,
      swiperOptions: {
        initialSlide: 1, // 从第一张开始播放
        slidesPerView: 1, // 一行显示1个
        speed: 2000, // 滑动速度
        effect: "flip",
        loop: true, // 启用循环
        slideToClickedSlide: true,
        loopedSlides: 1, // 只克隆1个幻灯片
        spaceBetween: 0,
        autoplay: {
          delay: 4000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        navigation: {
          nextEl: ".swiper-button-next-ex-pc",
          prevEl: ".swiper-button-prev-ex-pc",
        },
        on: {
          init: (swiper) => {
            // 确保初始化时显示第一张真实幻灯片
            that.currentIndex = 1;
          },
          slideChange: (swiper) => {
            that.currentIndex = swiper.realIndex + 1;
          },
        },
      },
      swiperOption_m: {
        initialSlide: 1, // 从第一张开始播放
        direction: "horizontal",
        autoplay: {
          delay: 500000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        loop: true, // 启用循环
        slideToClickedSlide: true,
        loopedSlides: 1, // 只克隆1个幻灯片
        slidesPerView: 1, // 确保移动端显示1个幻灯片
        centeredSlides: false, // 修复：禁用居中显示，避免与循环冲突
        spaceBetween: 40,
        navigation: {
          nextEl: ".swiper-button-next-ex-m",
          prevEl: ".swiper-button-prev-ex-m",
        },
        on: {
          init: (swiper) => {
            // 确保初始化时显示第一张真实幻灯片
            that.currentIndex_m = 1;
          },
          slideChange: (swiper) => {
            that.currentIndex_m = swiper.realIndex + 1;
          },
        },
      },
    };
  },
  methods: {
    // 确保显示第一张幻灯片
    ensureFirstSlide() {
      if (this.$refs.mySwiper && this.$refs.mySwiper.swiper) {
        // 强制跳转到第一张真实幻灯片
        this.$refs.mySwiper.swiper.slideTo(0, 0);
      }
    },
    
    // 绑定全局点击事件
    bindGlobalClickEvents() {
      document.addEventListener('click', this.handleGlobalClick);
    },
    
    // 处理全局点击事件
    handleGlobalClick(event) {
      // 检查点击的元素是否在swiper容器内
      const swiperContainer = document.querySelector('.exhibition_box');
      if (!swiperContainer || !swiperContainer.contains(event.target)) {
        return;
      }
      
      // 查找最近的带有data-item属性的元素
      let target = event.target;
      let item = null;
      
      while (target && target !== swiperContainer) {
        if (target.dataset && target.dataset.item) {
          try {
            item = JSON.parse(target.dataset.item);
            break;
          } catch (e) {
            // 解析失败，继续查找
          }
        }
        target = target.parentElement;
      }
      
      // 如果找到了数据，执行跳转
      if (item) {
        event.preventDefault();
        event.stopPropagation();
        this.toDetail(item);
      }
    },
    
    toDetail(item) {
      const obj = { event: "trk", ec: "news", ea: "readmore", el: "viewmore" };
      dataLayer.push(JSON.parse(JSON.stringify(obj)));
      let params = this.$route.query;
      document.body.scrollTop = document.documentElement.scrollTop = 0;
      this.$store.commit("activeIndex", 3);
      this.$router.push({
        name: "Exhibition",
        query: {
          track: params.track ? params.track : "",
          utm_source: params.utm_source ? params.utm_source : "",
          utm_medium: params.utm_medium ? params.utm_medium : "",
          utm_campaign: params.utm_campaign ? params.utm_campaign : "",
          utm_content: params.utm_content ? params.utm_content : "",
          se_sr: params.se_sr ? params.se_sr : "",
          se_md: params.se_md ? params.se_md : "",
          se_ct: params.se_ct ? params.se_ct : "",
          tab: this.tab ? "true" : "false",
          title: item.title,
        },
      });
    },
  },
  computed: {
    clientWidth() {
      return this.$store.state.clientWidth;
    },
    list() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 6);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub, subIndex) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 6) {
          index += 1;
        }
      });
      let eles;
      if (arr.length === 1 && arr) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "none";
          }
        }
      } else if (arr.length > 1) {
        eles = document.querySelectorAll(".swiper-button1");
        if (eles && eles.length) {
          for (const n of eles) {
            n.style.display = "flex";
          }
        }
      }
      return arr;
    },
    listm() {
      let arr = [];
      let i = Math.ceil(this.currentData.length / 4);
      for (let ind = 0; ind < i; ind++) {
        arr.push({
          children: [],
        });
      }
      let index = 0;
      this.currentData.map((sub, subIndex) => {
        arr[index].children.push(sub);
        if (arr[index].children.length >= 4) {
          index += 1;
        }
      });
      return arr;
    },
  },
  watch: {
    tab() {
      document.querySelector(".exhibition_box").style.opacity = 0;
      setTimeout(() => {
        document.querySelector(".exhibition_box").style.opacity = 1;
        // 重置当前索引
        this.currentIndex = 1;
        this.currentIndex_m = 1;
        // 确保切换后显示第一张幻灯片
        this.$nextTick(() => {
          this.ensureFirstSlide();
        });
      }, 100);
      if (this.tab) {
        this.currentData = this.data.energy;
      } else {
        this.currentData = this.data.industrial;
      }
    },
    currentData() {
      // 数据变化时重置索引
      this.currentIndex = 1;
      this.currentIndex_m = 1;
      this.$nextTick(() => {
        this.ensureFirstSlide();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>